import './styles/app.css';

import React from 'react';
import {Route, withRouter} from 'react-router-dom';

import IndexContainer from './containers';
import {inject, observer} from "mobx-react/index";
import { CircularProgress } from 'material-ui/Progress';

const App = (app_store) => {

    const store = app_store.app_store;

    store.fetch();

    if (!store.is_fetched) {
        return (
            <div className="text-center" style={{marginTop: '36px'}}>
                <div><CircularProgress /></div>
                <p><small>Carregando...</small></p>
            </div>
        )
    }

    return (<Route component={IndexContainer} />);
}

let container = observer(App);
container = inject(['app_store'])(container);

export default withRouter(container);



// WEBPACK FOOTER //
// ./src/App.js